import { trpc } from 'root/src/client/v2/trpc/trpc';
import { DROPS_DEFAULT_TAB, DROPS_STALE_TIME_MS, DROPS_STATUS_TAB_ID, DROPS_TAB_SECTION_MAP, DropsFilter, } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
import { DropSerializer } from 'root/src/shared/drops/drops.constants';
import { StringQueryParam } from 'root/src/client/v2/queryParams/helpers/params.helper';
import { useQueryParam } from 'use-query-params';
export const useTabAvailableFilters = () => {
    var _a, _b;
    const [tab] = useQueryParam(DROPS_STATUS_TAB_ID, StringQueryParam({ default: DROPS_DEFAULT_TAB }));
    const dropsQuery = trpc.drops.getDrops.useQuery({
        section: DROPS_TAB_SECTION_MAP[tab],
        serializer: DropSerializer.LIST_VIEW,
        dataFilter: DropsFilter.Default,
    }, {
        staleTime: DROPS_STALE_TIME_MS,
    });
    return {
        isLoading: dropsQuery.isLoading,
        availableFilters: ((_a = dropsQuery === null || dropsQuery === void 0 ? void 0 : dropsQuery.data) === null || _a === void 0 ? void 0 : _a.availableFilters) || [],
        defaultFilter: ((_b = dropsQuery === null || dropsQuery === void 0 ? void 0 : dropsQuery.data) === null || _b === void 0 ? void 0 : _b.filter) || DropsFilter.All,
    };
};
